import { ComponentDataSourceItem } from '../types';
import { ComponentRow } from './ComponentRow';
import { ComponentTreeWrapper } from '../atoms';
import { EXPORT_AUTOSIZE_CLASS_NAME } from '@ardoq/global-consts';
import { type I18nLocale, t } from '@ardoq/i18n';

type ComponentTreeProps = {
  dataSource: ComponentDataSourceItem[];
  i18nLocale: I18nLocale;
};

export const ComponentTree = ({
  dataSource,
  i18nLocale,
}: ComponentTreeProps) => (
  <ComponentTreeWrapper
    className={EXPORT_AUTOSIZE_CLASS_NAME}
    role="tree"
    aria-label={t(
      i18nLocale,
      'tabview:componentTree.visualizationAriaLabel',
      'Component Tree Visualization'
    )}
  >
    {dataSource.map(dataSourceItem => (
      <ComponentRow
        key={dataSourceItem.id}
        componentId={dataSourceItem.id}
        {...dataSourceItem}
      />
    ))}
  </ComponentTreeWrapper>
);
